import type { KidMarker } from '../../../../../../../api/kids/types';
import { SRI_MARKER } from './markerMappings';

/** Returns the subset of API markers that belong to a preset block tag. */
export function getMarkersForPresetTag(
  tag: string,
  allMarkers: KidMarker[],
): KidMarker[] {
  switch (tag) {
    case 'sri_chart':
      return allMarkers.filter(
        (m) =>
          m.marker_type === SRI_MARKER.markerType &&
          m.placeholder === SRI_MARKER.placeholder,
      );
    case 'composition_of_costs_table':
      return allMarkers.filter((m) => m.marker_type === 'COST');
    case 'costs_over_time_table':
      return allMarkers.filter(
        (m) =>
          m.marker_type === 'FIG' &&
          (m.placeholder.startsWith('total_cost_') ||
            m.placeholder.startsWith('riy_')),
      ).concat(
        allMarkers.filter(
          (m) =>
            m.marker_type === 'FUND' &&
            (m.placeholder === 'fund_currency' ||
              m.placeholder === 'holding_period'),
        ),
      );
    case 'performance_scenarios_table':
      return allMarkers.filter(
        (m) =>
          m.marker_type === 'FIG' &&
          (m.placeholder.includes('amount_back') ||
            m.placeholder.includes('return_back')),
      ).concat(
        allMarkers.filter(
          (m) =>
            m.marker_type === 'FUND' && m.placeholder === 'holding_period',
        ),
      );
    default:
      return [];
  }
}
